import React, { useEffect, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShare, faRedo } from '@fortawesome/free-solid-svg-icons'

import ThankYouMessage from './ThankYouMessage'
import ThankYouInfo from './ThankYouInfo'
import Comment from './Comment'
import EmployerMatchingResults from './EmployerMatchingResults'

const Finished = ({
  i18n, removeProfileLink, social, share_modal, thankYouInfo, donationsPath,
  donate_again, donation, setDonation, postDonationComment, plugins, paymentMethod,
  employerMatching,
}) => {
  const element = useRef()

  useEffect(() => {
    if (!donation) return

    const setFocus = () => element.current.querySelector('.focus-target').focus()
    const timeout = setTimeout(setFocus, 66)
    return () => clearTimeout(timeout)
  }, [ !!donation ])

  if (!donation) return null

  const renderThankYouInfo = donation.token && thankYouInfo?.enabled && thankYouInfo?.label.trim()
  const renderComment = !renderThankYouInfo && donation.token && postDonationComment

  return (
    <div ref={element} className="finished d-flex flex-column gap-3 gap-sm-4">
      {plugins.renderHook('beforeThankYou', paymentMethod, { donation })}

      <div className="thankyou thankyou-default bg-light px-3 py-4 px-sm-4 py-sm-5 rounded-4">
        <div className="thankyou-inner mb-n3 mx-auto" style={{ maxWidth: '30rem' }}>
          <h2 tabIndex={-1} className="h5 mb-3 thankyou-heading focus-target">
            {i18n.t('thankyou.header')}
          </h2>

          {
            renderComment
          ? <Comment
              i18n={i18n}
              donationsPath={donationsPath}
              donation={donation}
            />
          : <ThankYouMessage
              i18n={i18n}
              beneficiary={donation.partnerItem.beneficiary}
              removeProfileLink={removeProfileLink}
            />
          }

          {
            (social || donate_again) &&
            <div className="mt-4 mb-3 d-flex gap-2 flex-wrap">
              {
                social &&
                <button
                  type="button"
                  className="btn btn-primary"
                  data-plg-modal-label={i18n.t('share_button')}
                  data-plg-modal-src={share_modal?.src}
                  data-plg-modal-id={share_modal?.id}
                >
                  <FontAwesomeIcon icon={faShare} className="me-2" />
                  {i18n.t('share_button')}
                </button>
              }
              {
                donate_again &&
                <button
                  type="button"
                  className="btn btn-donate-again"
                  onClick={() => setDonation(null)}
                >
                  <FontAwesomeIcon icon={faRedo} className="me-2" />
                  {i18n.t('donate_again_button')}
                </button>
              }
            </div>
          }
        </div>
      </div>

      {
        renderThankYouInfo &&
        <ThankYouInfo
          i18n={i18n}
          thankYouInfo={thankYouInfo}
          donationsPath={donationsPath}
          donation={donation}
        />
      }

      {donation.afterThankYou?.()}

      {/* Last on the panel, per DTD certification. The uuid guard only excludes stock. */}
      {
        donation.uuid && employerMatching?.enabled &&
        <EmployerMatchingResults
          employerMatching={employerMatching}
          donation={donation}
          donationsPath={donationsPath}
        />
      }
    </div>
  )
}

export default Finished
